import {EmptyControl, MaxLength, MinLength, NestedArray, Required} from '@hvlng/framework-bff/core';
import {HvlDateConverter} from '@hvlng/framework-bff/util';
import {JsonObject, JsonProperty} from 'json2typescript';

@JsonObject('KovanHrPerAdvancedSearchRuleModel')
export class PerAdvancedSearchRuleModel {
    @EmptyControl()
    @JsonProperty('field', String, true)
    field: string = null;

    @EmptyControl()
    @JsonProperty('operator', String, true)
    operator: string = null;

    @EmptyControl()
    @JsonProperty('value', String, true)
    value: string = null;

    @EmptyControl()
    @JsonProperty('valueText', String, true)
    valueText: string = null;

    @EmptyControl()
    @JsonProperty('entity', String, true)
    entity: string = null;

    @EmptyControl()
    @JsonProperty('type', String, true)
    type: string = null;

}
